import { IMessageType } from '../types';

import { INotificationUserUpdateReqMsg } from '~/api/messages/INotificationUserUpdateReqMsg';
import { INotificationUserUpdateRespMsg } from '~/api/messages/INotificationUserUpdateRespMsg';

export const NotificationUserUpdateReqMsg:
IMessageType<INotificationUserUpdateReqMsg, INotificationUserUpdateRespMsg> = {
  requestName: 'NotificationUserUpdateReqMsg',
  responseName: 'NotificationUserUpdateRespMsg',
};
